import React from "react";

const CTA = () => {
  return (
    <section className="bg-[--st-color-cream] px-4 py-14 sm:py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl">
        <div className="st-cta-product1-panel rounded-[36px] rotate-[-2deg] px-6 py-10 text-center sm:rounded-[44px] sm:px-12 sm:py-14 lg:rounded-[56px] lg:px-20 lg:py-16">
          <h2 className="st-cta-product1-title st-font-display mx-auto max-w-[760px] text-[24px] leading-[1.05] sm:text-[28px] md:text-[36px] lg:text-[42px]">
            Kami tidak membangun <span className="font-bold italic">ScholarsToday</span>
            <br />
            untuk jadi kursus IELTS <span className="font-bold italic">terbesar</span>. Kami
            <br />
            membangunnya untuk jadi yang paling
            <br />
            bisa kamu <span className="font-bold italic">percaya</span>.
          </h2>

          <p className="st-cta-product1-subtitle st-font-body mx-auto mt-5 max-w-3xl text-[18px] leading-[1.35] sm:mt-6 sm:text-[20px] md:text-[22px]">
            Kalau kamu <span className="font-bold">serius mengejar</span> beasiswa impianmu, kami <span className="font-bold">serius
            menemanimu</span> sampai akhir.
          </p>

          <div className="mx-auto mt-8 flex w-full max-w-[860px] flex-col gap-4 sm:mt-10 sm:gap-5">
            <a
              href="https://wa.me/+6288228773929?text=Halo,%20saya%20mau%20daftar%20kelas%20IELTS"
              target="_blank"
              rel="noopener noreferrer"
              className="st-cta-product1-primary-btn st-focus-ring st-font-body inline-flex h-14 items-center justify-center rounded-full px-8 text-[20px] font-semibold sm:h-16 sm:text-[32px] lg:text-[36px]"
            >
              Mulai Perjalananmu!
            </a>

            <a
              href="https://wa.me/+6288228773929?text=Halo,%20saya%20mau%20tanya-tanya%20dulu%20tentang%20kelas%20IELTS"
              target="_blank"
              rel="noopener noreferrer"
              className="st-cta-product1-secondary-btn st-focus-ring st-font-body inline-flex h-14 items-center justify-center rounded-full bg-transparent px-8 text-[20px] font-semibold sm:h-16 sm:text-[32px] lg:text-[36px]"
            >
              Konsultasi Gratis sama Minday
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;